export interface ErrorState {
    isActive: boolean;
    message: string | null;
}

export const NullErrorState: ErrorState = {
    isActive: false,
    message: null,
};

export const useErrorMessages = (errors: readonly ErrorState[]): string | null => {
    const activeError = errors.find((error) => error.isActive);
    if (activeError) {
        return activeError.message;
    }
    return null;
};
